// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1DayPropertiesCreateSchema } from './v1/dayProperties/createSchema';
import { v1DayPropertySchema } from './v1/dayPropertySchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const createDayPropertiesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createDayPropertiesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Day properties created successfully
 */
export const createDayProperties201Schema = z.array(z.lazy(() => v1DayPropertySchema));

/**
 * @description Unauthorized
 */
export const createDayProperties401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Validation errors
 */
export const createDayProperties422Schema = z.lazy(() => v1ValidationErrorSchema);

export const createDayPropertiesMutationRequestSchema = z.lazy(() => v1DayPropertiesCreateSchema);

export const createDayPropertiesMutationResponseSchema = z.lazy(() => createDayProperties201Schema);
